import {EUnnecessaryValueConditions} from 'components/table-report/utils/table-report-utils';
import {isEnumInstance} from 'shared/utils';

export const isConditionValueUnnecessary = (condition: string | undefined) => {
    if (!condition) {
        return false;
    }
    return isEnumInstance(condition, EUnnecessaryValueConditions);
};
